<template>
  <v-toolbar
      flat
  >
    <v-btn
        outlined
        class="mr-4"
        color="grey darken-2"
        @click="$emit('setToday', today)"
    >
      {{$t('planning.today')}}
    </v-btn>
    <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="prev"
    >
      <v-icon small>
        mdi-chevron-left
      </v-icon>
    </v-btn>
    <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="next"
        class="mr-4"
    >
      <v-icon small>
        mdi-chevron-right
      </v-icon>
    </v-btn>
    <v-toolbar-title v-if="refCalendar">
      {{ refCalendar.title.charAt(0).toUpperCase()+ refCalendar.title.slice(1)}}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
        bottom
        right
    >
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ToolbarCalendar',
  props: ['getRefCalendar', 'today', 'type'],
  data () {
    return {
      refCalendar: ''
    }
  },
  methods: {
    prev () {
      this.refCalendar.prev()
      this.$emit('prevClicked', { date: this.refCalendar.value })
    },
    next () {
      this.refCalendar.next()
      this.$emit('nextClicked', { date: this.refCalendar.value })
    }
  },
  mounted () {
    this.refCalendar = this.getRefCalendar().calendar
  }
}
</script>
